import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a3119cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar navbar-expand" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "col-auto d-desktop-inline-block" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " Warenkorb ", -1))

import {
  reactive,
  onBeforeMount,
  onMounted,
  onBeforeUnmount,
  computed,
  nextTick,
  ref,
} from 'vue';
import { useStore } from 'vuex';
import IoSearchForm from '@/components/IoSearchForm.vue';
import IoSidebar from '@/components/IoSidebar.vue';
import MenuInterface from '@/interfaces/MenuInterface';
import CartWidget from '@/components/CartWidget.vue';
import HeaderTop from '@/components/BaseHeader/BaseHeaderTop.vue';
import IconCart from '@/components/IconCart.vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faBars } from '@fortawesome/pro-light-svg-icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseHeader',
  setup(__props) {

library.add(faBars);

const store = useStore();
const logoSrc = window.ioappConfig.logo;
const logoBar = ref();
const navBar = ref();
const isMobile = ref(false);
const isDesktop = computed(() => !isMobile.value);

const header = reactive({
  top: 0,
  $el: null as null | HTMLElement,
});

const currentPage = computed(() => store.getters['page/page']);

const activeMenuItems = (menuItems: MenuInterface[]) => {
  let aMenuItems: MenuInterface[] = [];
  let hasActive = false;

  if (Array.isArray(menuItems) && menuItems.length) {
    aMenuItems = menuItems.map((menuItem) => {
      const nMenuItem = menuItem;
      nMenuItem.active = currentPage.value.url === nMenuItem.url;
      if (menuItem.children) {
        const menuItemChildren = activeMenuItems(nMenuItem.children || []);
        nMenuItem.children = menuItemChildren.items;

        nMenuItem.active = nMenuItem.active || menuItemChildren.active;
      }

      hasActive = hasActive || nMenuItem.active;

      return nMenuItem;
    });
  }

  return {
    items: aMenuItems,
    active: hasActive,
  };
};

const menu = computed(() => {
  const $pageVal = currentPage.value;

  return $pageVal
    ? activeMenuItems(store.getters['menus/menu']('header')).items
    : store.getters['menus/menu']('header');
});

const getDepth = (menuItems: MenuInterface[]): number => {
  const depth = (menuItems && menuItems.length) ? 1 : 0;
  let menuItemsMaxDepth = 0;

  (menuItems || []).forEach((menuItem) => {
    const menuItemMaxDepth = Array.isArray(menuItem.children)
      ? 1 + Math.max(...menuItem.children.map((mItem) => getDepth(mItem.children || [])))
      : 0;

    if (menuItemMaxDepth > menuItemsMaxDepth) {
      menuItemsMaxDepth = menuItemMaxDepth;
    }
  });

  return depth + menuItemsMaxDepth;
};

const menuDepth = computed(() => getDepth(menu.value || []));
const menuItemsTop = computed(() => {
  let $menuItemsTop: MenuInterface[] = [];

  if (menuDepth.value >= 3) {
    $menuItemsTop = [...menu.value].map((menuItem) => {
      const nMenuItem = { ...menuItem };

      delete nMenuItem.children;

      return nMenuItem;
    });
  }

  return $menuItemsTop;
});

const setHeaderPos = () => {
  header.top = 0;

  nextTick(() => {
    const $wpAdminBar = document.querySelector('#wpadminbar') as HTMLElement;
    const $body = document.querySelector('body');
    let top = 0;

    if ($wpAdminBar) {
      top += $wpAdminBar.offsetHeight;
    }

    header.top = top;

    if ($body && header.$el) {
      $body.style.paddingTop = `${header.$el.offsetHeight}px`;
    }
  });
};
const minAmountToScroll = ref(0);
const scrollTop = ref(0);
const hideHeader = ref(false);

const setHeaderTop = () => {
  minAmountToScroll.value = 0;
  if (header.$el) {
    minAmountToScroll.value += header.$el.offsetHeight;
  }

  const $wpAdminBar = document.querySelector('#wpadminbar') as HTMLElement;
  if ($wpAdminBar) {
    minAmountToScroll.value += $wpAdminBar.offsetHeight;
  }

  if (window.scrollY > minAmountToScroll.value && window.scrollY > scrollTop.value) {
    hideHeader.value = true;
    store.dispatch('search/close');
  } else {
    hideHeader.value = false;
  }

  scrollTop.value = window.scrollY;
};

const checkIfMobile = () => {
  if (navBar.value && logoBar.value) {
    isMobile.value = false;

    nextTick(() => {
      navBar.value.style.position = 'absolute';
      logoBar.value.style.position = 'absolute';
      const parentStyle = window.getComputedStyle(navBar.value.parentElement);
      const maxWidth = navBar.value.parentElement.offsetWidth
          - parseFloat(parentStyle.paddingLeft)
          - parseFloat(parentStyle.paddingRight);
      const navBarWidth = navBar.value.offsetWidth;
      const logoBarWidth = logoBar.value.offsetWidth;

      if ((navBarWidth + logoBarWidth) > maxWidth) {
        isMobile.value = true;
      }

      navBar.value.style.position = '';
      logoBar.value.style.position = '';
    });
  }
};

onBeforeMount(() => {
  store.dispatch('menus/fetchBySlug', 'header');
});

onMounted(() => {
  header.$el = document.querySelector('header');
  window.addEventListener('resize', setHeaderPos);
  window.addEventListener('load', setHeaderPos);
  window.addEventListener('scroll', setHeaderTop);
  window.addEventListener('resize', checkIfMobile);
  window.addEventListener('load', checkIfMobile);
  setHeaderPos();
  setHeaderTop();
  checkIfMobile();
  for (let i = 100; i < 1000; i += 100) {
    setTimeout(setHeaderPos, i);
    setTimeout(setHeaderTop, i);
  }
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', setHeaderPos);
  window.removeEventListener('load', setHeaderPos);
  window.addEventListener('scroll', setHeaderTop);
  window.removeEventListener('resize', checkIfMobile);
  window.removeEventListener('load', checkIfMobile);
});

const cartEnabled = window.ioappConfig.env?.CART_ENABLED || false;

const toggleSidebar = () => {
  store.dispatch('sidebar/toggle', 'sidebar');
};

return (_ctx: any,_cache: any) => {
  const _component_IoRouterLink = _resolveComponent("IoRouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", {
      style: _normalizeStyle(`top:${header.top}px`),
      class: _normalizeClass(["d-print-none", {
        'slide-up': hideHeader.value,
        'desktop': isDesktop.value,
        'mobil': isMobile.value,
      }])
    }, [
      (menuItemsTop.value.length)
        ? (_openBlock(), _createBlock(HeaderTop, {
            key: 0,
            items: menuItemsTop.value
          }, null, 8, ["items"]))
        : _createCommentVNode("", true),
      _createElementVNode("nav", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            ref_key: "logoBar",
            ref: logoBar,
            class: _normalizeClass(["row brand-row g-0 d-desktop-block", { 'justify-content-end': isDesktop.value }])
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_IoRouterLink, {
                "link-url": "https://energiehoch3.de/",
                class: "brand-image-link"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: _unref(logoSrc),
                    alt: "",
                    loading: "lazy"
                  }, null, 8, _hoisted_4)
                ]),
                _: 1
              })
            ])
          ], 2),
          _createElementVNode("div", {
            ref_key: "navBar",
            ref: navBar,
            class: "d-flex navbar-nav align-items-center text-center col"
          }, [
            _hoisted_5,
            (_unref(cartEnabled))
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  class: _normalizeClass(["nav-link nav-link__other", { 'last': isDesktop.value && _unref(cartEnabled) }]),
                  href: "/warenkorb/",
                  title: "Warenkorb öffnen"
                }, [
                  _createVNode(IconCart),
                  _hoisted_6
                ], 2))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: _normalizeClass(["nav-link nav-link__other sidebar-toggle", { 'last': isMobile.value }]),
              onClick: toggleSidebar
            }, [
              _createVNode(_unref(FontAwesomeIcon), { icon: "fa-light fa-bars" })
            ], 2)
          ], 512)
        ])
      ])
    ], 6),
    _createVNode(IoSearchForm),
    _createVNode(IoSidebar, {
      items: menu.value || []
    }, null, 8, ["items"]),
    _createVNode(CartWidget)
  ], 64))
}
}

})